module.exports = __webpack_public_path__ + "static/media/eye.7379efa3.svg";